import ScrollLinkItem from '../atoms/ScrollLinkItem';

type Props = {
  items: { anchor: string; title: string; hidden?: boolean }[];
};

/**
 * 同一ページ内スクロールリンクの一覧表示コンポーネント。
 * @param param0 アンカー一覧
 * @returns スクロールリンク一覧
 */
const ScrollLinkList = ({ items }: Props) => {
  return (
    <ul className='m-list-link m-list-link--side'>
      {/* hidden 指定のある項目は描画せず、表示対象だけサイドリンク化する。 */}
      {items.map(
        (item) =>
          !item.hidden && (
            <ScrollLinkItem anchor={item.anchor} title={item.title} key={item.anchor} />
          )
      )}
    </ul>
  );
};

export default ScrollLinkList;
